<template>
  <div :dir="language == 'en-RS' ? 'rtl' : 'ltr'">
    <el-config-provider
      :locale="appStore.locale"
      :size="appStore.size"
    >
      <router-view />
    </el-config-provider>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue';
import { useSettingsStore } from '@/store/modules/settings.ts';
import { handleThemeStyle } from '@/utils/theme.ts';
import { useAppStore } from '@/store/modules/app.ts';
const language = ref(null);

const appStore = useAppStore();
watch(
  () => appStore.language,
  (val) => {
    language.value = val;
  },
  { immediate: true },
);
onMounted(() => {
  nextTick(() => {
    // 初始化主题样式

    handleThemeStyle(useSettingsStore().theme);
  });
});
</script>
<style lang="scss">
.exportBtn {
  text-align: center;
  margin-top: 10px;
}

body {
}
// 初始化element组件
.el-button + .el-button {
  margin-inline-start: 10px;
}
.el-tabs__nav {
  float: inline-start !important;
}
.el-tabs__item:last-child {
  padding-inline-start: 20px !important;
  padding-inline-end: 20px !important;
}
.el-tree-node__content {
  padding-inline-end: 10px !important;
}
.el-radio {
  margin-inline-start: 30px !important;
  .el-radio__label {
    margin-inline-start: 4px !important;
  }
}
.el-dialog__headerbtn {
  right: auto !important; /* 先重置原有的物理属性 */
  inset-inline-end: 0 !important; /* 再设置逻辑属性 */
}
.el-dialog__footer {
  text-align: end !important;
}
.el-table {
  .cell {
    text-align: start;
    font-size: 14px;
  }
}
.el-checkbox__label {
  padding-inline-start: 8px !important;
}
.el-table__header th {
  // border-inline-end: none !important;
  padding: 0 8px;
  height: 50px !important;
  color: #333;
  font-weight: 600;
  border-inline-end: #f5f7fa 2px solid !important;
  background: #f2f3f5 !important;
  &:hover {
    background: #eeeeee !important;
    // border-inline-end: 1px solid #dfe6ec !important;
  }
}
</style>
